// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3679f923","239":"cee2d161","453":"3132e9d7","455":"74415cd2"}[chunkId] + ".chunk.js";
};